var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.maxLength") } },
    [
      _c("el-input", {
        staticClass: "hide-spin-button",
        staticStyle: { width: "100%" },
        attrs: { type: "number", min: "1" },
        nativeOn: {
          input: function ($event) {
            return _vm.inputNumberHandler($event)
          },
        },
        model: {
          value: _vm.maxLength,
          callback: function ($$v) {
            _vm.maxLength = $$v
          },
          expression: "maxLength",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }